{
    "UserNotificationBusyTime": "Receive a notification when your team is busy.",
    "UserNotificationMissedCalls": "Receive a notification when a specific amount of calls have been missed within 60 Minutes.",
    "UserNotificationWeeklyInsightsReport": "Receive a weekly performance report.",
    "UserNotificationUserNotLoggedIn7Days": "Receive a notification when a you have not logged in for 7 days.",
    "UserNotificationAvgAnswerTime": "Receive a notification when your average answer time exceeds a specific amount of Seconds on half hour intervals.",
    "UserNotificationUserNeverLoggedIn": "Receive a notification when you dont log in.",
    "NAME": "UserNotificationTypesHelp"
}